import React, { useState, useMemo } from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/layout';
import { useForm, FormProvider } from 'react-hook-form';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from 'react-router-dom';
import { ROUTES } from 'consts';


const policiesEdit = {
  type: {
    name: 'type',
    input: 'select',
    label: 'workflowEdit.components.task.form.add.type',
  },
  satisfy: {
    name: 'satisfy',
    input: 'select',
    label: 'workflowEdit.components.task.form.add.satisfy.label',
  },
}

const optionsSatisfy = [
  { value: "T", label: 'workflowEdit.components.task.form.add.satisfy.optionAll' },
  { value: "A", label: 'workflowEdit.components.task.form.add.satisfy.optionSome' }
];

export default function EditTaskComponent({ task, optionsType, optionsAction, counterNode, handleEdit, handleCancel, handleDelete }) {
  const [t] = useTranslation();
  const type = task.description === "SI" ? "template" : "workflow";
  const [isEditMode, setIsEditMode] = useState(false);
  const methods = useForm({
    defaultValues: {
      type: optionsType[0].value,
      satisfy: optionsSatisfy[0].value
    }
  });
  const { handleSubmit, watch } = methods;
  const watchEndEvent = watch('endEvent');

  function getRouteNewTab() {
    let redirectTo = "";
    if (type === "template") redirectTo = `${ROUTES.TEMPLATE_EDIT}/${task.id_Plantilla}`;
    else redirectTo = `${ROUTES.WORKFLOW_EDIT}/${task.id_Plantilla}`;
    return redirectTo;
  }

  function handleOnSubmit(data) {
    const typeFound = optionsType.find(element => element.value === data.type);

    if (!typeFound) return;

    const objectNode = {
      ...task,
      id_Plantilla: typeFound.value,
      title: typeFound.label,
      description: typeFound.type_template,
      type: typeFound.type,
      hasUserAction: typeFound.user_interaction,
    };

    handleEdit(objectNode, task.id_nodo);
  }

  if (isEditMode) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
      <FormProvider { ...methods }>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <Box sx={{ display: 'flex', p: 2, flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6">{t('workflowEdit.components.task.addLabel')}</Typography>
            <Divider />

            <Input
              {...policiesEdit.satisfy}
              options={optionsSatisfy}
              sx={{ width: '100%' }}
              disabled={!watchEndEvent}
              display={watchEndEvent ? 'inherit' : 'none'}
            />
            <Input
              {...policiesEdit.type}
              options={optionsType}
              sx={{ width: '100%' }}
              disabled={watchEndEvent}
              display={watchEndEvent ? 'none' : 'inherit'}
            />
            <Divider/>
            <Button variant="outlined" sx={{ width: '100%' }} type='submit'>
              {t('workflowEdit.components.task.form.save')}
            </Button>
          </Box>
        </form>
      </FormProvider>

      <Box sx={{ display: 'flex', px: 2, pb: 4, gap: 1 }}>
        <Button variant="text" sx={{ width: '100%' }} onClick={() => setIsEditMode(false)}>
          {t('workflowEdit.components.task.form.cancel')}
        </Button>
      </Box>
    </Box>
  );
  else return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
      <Box sx={{ display: 'flex', p: 2, flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6">{t('workflowEdit.components.task.editLabel')}</Typography>
        <Divider />

        <Box>
          {/*<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            { t(type === "workflow" ? 'workflowEdit.components.task.form.edit.workflow'
              : 'workflowEdit.components.task.form.edit.template')
            }
          </Typography>*/}
          <Typography variant="subtitle1">{task.title}</Typography>
        </Box>

        <Link to={getRouteNewTab} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <Button variant="outlined" sx={{ width: '100%' }} >
           <OpenInNewIcon variant="primary" fontSize="small" sx={{ mr: 1 }}/>
            {t('workflowEdit.components.task.form.newTab')}
          </Button>
        </Link>

        <Divider/>
        <Button variant="outlined" sx={{ width: '100%' }} onClick={() => setIsEditMode(true)}>
          {t('workflowEdit.components.task.form.editForm')}
        </Button>

      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pb: 4, justifyContent: 'flex-end' }}>
        <Button variant="text" sx={{ width: '100%' }} onClick={() => handleDelete(task)} color="error">
          {t('workflowEdit.components.task.form.delete')}
        </Button>
        <Button variant="text" sx={{ width: '100%' }} onClick={handleCancel}>
          {t('workflowEdit.components.task.form.cancel')}
        </Button>
      </Box>
    </Box>
  );
}
